"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/ConversationScreen/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _toolkit = require('@reduxjs/toolkit');
var _reactredux = require('react-redux');
var _querystring = require('query-string'); var _querystring2 = _interopRequireDefault(_querystring);
var _reactrouterdom = require('react-router-dom');

var _time = require('shared/services/time');
var _log = require('shared/log');
var _chat = require('shared/enum/chat');
var _secureText = require('shared/constants/secureText');
var _message = require('shared/validation/chat/message');
var _composer = require('shared/services/composer');





var _reactdropzone = require('react-dropzone'); var _reactdropzone2 = _interopRequireDefault(_reactdropzone);
var _ExpandingInput = require('web/components/Conversation/ExpandingInput'); var _ExpandingInput2 = _interopRequireDefault(_ExpandingInput);
var _SendLaterPanel = require('web/components/Conversation/SendLaterPanel'); var _SendLaterPanel2 = _interopRequireDefault(_SendLaterPanel);
var _ScheduledEditBar = require('web/components/Conversation/ScheduledEditBar'); var _ScheduledEditBar2 = _interopRequireDefault(_ScheduledEditBar);
var _CancelScheduledModal = require('web/components/Conversation/CancelScheduledModal'); var _CancelScheduledModal2 = _interopRequireDefault(_CancelScheduledModal);
var _ScheduledCancelToast = require('web/components/Conversation/ScheduledCancelToast'); var _ScheduledCancelToast2 = _interopRequireDefault(_ScheduledCancelToast);
var _scheduledCancels = require('shared/services/scheduledCancels'); var _scheduledCancels2 = _interopRequireDefault(_scheduledCancels);
var _scheduledMessages = require('shared/services/scheduledMessages');
var _scheduledMessages3 = require('shared/selectors/scheduledMessages');
var _useScheduledMessageFlow = require('shared/hooks/scheduledMessages/useScheduledMessageFlow');
var _scheduleTimeZone = require('web/services/scheduleTimeZone');
var _timeZones = require('shared/services/timeZones');
var _ReplyBar = require('web/components/Conversation/ReplyBar'); var _ReplyBar2 = _interopRequireDefault(_ReplyBar);
var _AttachmentTray = require('web/components/Conversation/AttachmentTray'); var _AttachmentTray2 = _interopRequireDefault(_AttachmentTray);
var _UploadStatus = require('web/components/Conversation/UploadStatus'); var _UploadStatus2 = _interopRequireDefault(_UploadStatus);
var _stagedFiles = require('./stagedFiles');
var _ComposerHint = require('web/components/Conversation/ComposerHint'); var _ComposerHint2 = _interopRequireDefault(_ComposerHint);


var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);

var _StoreConversationBox = require('web/screens/ConversationScreen/StoreConversationBox'); var _StoreConversationBox2 = _interopRequireDefault(_StoreConversationBox);
var _markReadOnOpen = require('./markReadOnOpen');
var _sort = require('shared/services/sort');
var _store = require('web/store');
var _hooks = require('web/services/hooks');
var _user = require('shared/selectors/user');









var _conversation = require('shared/selectors/conversation');


var _blobject = require('shared/selectors/blobject');

var _myRelations = require('shared/selectors/myRelations');

var _ConfirmDeleteModal = require('web/components/Conversation/Message/ConfirmDeleteModal'); var _ConfirmDeleteModal2 = _interopRequireDefault(_ConfirmDeleteModal);
var _string = require('shared/services/string');
var _uuid = require('shared/services/uuid');
var _RejoinModal = require('./RejoinModal'); var _RejoinModal2 = _interopRequireDefault(_RejoinModal);
var _SMSUndeliverableBanner = require('web/components/SMSUndeliverableBanner'); var _SMSUndeliverableBanner2 = _interopRequireDefault(_SMSUndeliverableBanner);
var _ui = require('web/services/ui');
var _navigation = require('web/actions/navigation');
var _noticeBar = require('web/services/context/noticeBar');
var _useSMSRejectionNotices = require('shared/hooks/useSMSRejectionNotices');
var _peers = require('shared/selectors/peers');
var _team = require('shared/selectors/team');
var _org = require('shared/selectors/org');
var _mentions = require('shared/services/mentions');
var _SearchHitInThread = require('web/screens/Search/Refined/SearchHitInThread'); var _SearchHitInThread2 = _interopRequireDefault(_SearchHitInThread);
var _SaveAsTemplateHost = require('web/components/MessageTemplates/SaveAsTemplateHost'); var _SaveAsTemplateHost2 = _interopRequireDefault(_SaveAsTemplateHost);
var _attachments = require('shared/constants/attachments');
var _ComposerTemplates = require('web/components/Conversation/ComposerTemplates');


var _useComposerSendForm = require('web/components/Forms/useComposerSendForm');

// Raises the one-time "unsubscribed from SMS" warning when a message this
// user sent comes back with a rejected text. A separate component so the
// hook's store subscriptions re-render only this, not the screen.
const SMSRejectionNotifier = _react.memo.call(void 0, ({ conversationKey }) => {
  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  _useSMSRejectionNotices.useSMSRejectionNotices.call(void 0, conversationKey, showWarningBar)
  return null
})

const MSGS_PER_BATCH = 30
// Names at most this many files left out of the tray, then "and N more".
const MAX_NAMED_LEFT_OUT = 3

const notAddedText = (leftOut) => {
  const named = leftOut.slice(0, MAX_NAMED_LEFT_OUT)
  const more = leftOut.length - named.length
  const names = named.map(file => file.name).join(', ')
  return `You can attach up to ${_attachments.MAX_ATTACHMENTS_PER_SEND} files at a time. Not added: ${names}${more ? ` and ${more} more` : ''}.`
}


const DROPZONE_INPUT_PROPS = { 'aria-label': 'Attach files' }

// The screen re-renders on every composer keystroke; these modals' props are
// stable (stable handlers, primitives), so memoizing them keeps typing from
// re-rendering two closed modals per character.
const MemoConfirmDeleteMessageModal = _react2.default.memo(_ConfirmDeleteModal2.default)
const MemoRejoinModal = _react2.default.memo(_RejoinModal2.default)
































const INITIAL_STATE = {
  finishedInitialLoad: false,
  currentMessage: "",
  draftKey: null,

  endReachedBelow: false,
  loadingAbove: false,
  loadingBelow: false,

  readOnly: true,
  messageToDelete: null,
  replyingTo: null,
  mentions: [],
  pendingFiles: [],
  fromTemplate: false,
}











const selectScreenState = (
  state,
  { blobjectKey, conversationKey },
) => {
  const currentUserKey = _user.selectCurrentUserKey.call(void 0, state)
  const lastSeenTime = _blobject.selectMyBlobjectLastSeenTime.call(void 0, state, blobjectKey)
  const inboxSortTime = _optionalChain([_blobject.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _ => _.InboxSortTime])
  const draft = _conversation.selectDraftByConversationKey.call(void 0, state, conversationKey) || ''
  const draftMentions = _conversation.selectDraftMentionsByConversationKey.call(void 0, state, conversationKey)
  const draftFromTemplate = _conversation.selectDraftFromTemplateByConversationKey.call(void 0, state, conversationKey)
  const readOnly =
    _conversation.selectShouldShowUpgradeNotice.call(void 0, state, blobjectKey) ||
    _conversation.selectShouldShowPatientUpgradeNotice.call(void 0, state, blobjectKey)
  const conversation = _conversation.selectConversationByKey.call(void 0, state, conversationKey)
  const conversationType = _conversation.selectConversationType.call(void 0, state, blobjectKey)
  const myOrgKey = _conversation.selectMyOrgKeyInConvo.call(void 0, state, blobjectKey)
  const amIOrgless = _myRelations.selectAmIOrgless.call(void 0, state)
  const totalMessagesCount = _optionalChain([conversation, 'optionalAccess', _2 => _2.MessageSequence])
  // The composer shows the number an SMS goes out from.
  const sendingNumber = _blobject.selectSendingNumber.call(void 0, state, blobjectKey)
  // Who a cancelled scheduled message won't go to.
  const cancelRecipientName = _scheduledMessages3.selectCancelRecipientName.call(void 0, state, blobjectKey)

  return {
    currentUserKey,
    myOrgKey,
    amIOrgless,
    lastSeenTime,
    inboxSortTime,
    draft,
    draftMentions,
    draftFromTemplate,
    readOnly,
    conversationType,
    totalMessagesCount,
    sendingNumber,
    cancelRecipientName,
  }
}



// Candidates depend only on this blobject's subscribers and the peer/team/org
// maps, so each mounted screen memoizes its own. Building them inline returned
// a fresh array on every dispatch and re-rendered the whole screen.
const makeSelectMentionCandidates = () => _toolkit.createSelector.call(void 0, 
  (state, blobjectKey) => _blobject.selectBlobjectByKey.call(void 0, state, blobjectKey),
  _peers.selectAllUsers,
  _peers.selectAllPatients,
  _team.selectTeams,
  _org.selectOrgs,
  (state, blobjectKey) => _conversation.selectMyOrgKeyInConvo.call(void 0, state, blobjectKey),
  _user.selectCurrentUserKey,
  _org.selectOrgsV2,
  (blobject, users, patients, teams, orgs, myOrgKey, myUserKey, orgsV2) => _mentions.buildMentionCandidates.call(void 0, {
    userSubscribers: _optionalChain([blobject, 'optionalAccess', _3 => _3.UserSubscribers]) || {},
    teamSubscribers: _optionalChain([blobject, 'optionalAccess', _4 => _4.TeamSubscribers]) || {},
    patientSubscribers: _optionalChain([blobject, 'optionalAccess', _5 => _5.PatientSubscribers]) || {},
    users,
    teams,
    patients,
    myOrgKey,
    myUserKey,
    // Orgs you don't belong to are only in the V2 store.
    orgName: orgKey => _optionalChain([orgs, 'optionalAccess', _6 => _6[orgKey], 'optionalAccess', _7 => _7.Name]) || _optionalChain([orgsV2, 'optionalAccess', _8 => _8[orgKey], 'optionalAccess', _9 => _9.Name]),
  }),
)














const KEEP_ZONE = () => undefined

const getMessageKey = (location) => {
  const values = _querystring2.default.parse(location.search) || {}
  // SAFETY: message links carry one messageKey (buildBlobjectRoute).
  return values.messageKey 
}

const focusComposer = () => {
  const inputElem = document.getElementById("main-input")
  if (inputElem) inputElem.focus()
}

const saveConversationDraft = (
  conversationKey,
  { currentMessage, mentions, fromTemplate },
) => {
  // A plain draft saves exactly as before; only a template draft carries the flag.
  _actions2.default.saveConversationDraft({ conversationKey, message: currentMessage, mentions, ...(fromTemplate && { fromTemplate }) })
}

/* Was a class component; its lifecycle is kept exactly:
 * - state is one object and every setState makes a new one (so it always
 *   re-renders), and a setState callback runs after the commit that applied
 *   it, after the componentDidUpdate logic, as React ran them for the class;
 * - the componentDidUpdate logic runs after every re-render against the
 *   previous render's props;
 * - every handler keeps one identity (the memoized children rely on it) and
 *   reads the latest props, state and context from a ref, as the class read
 *   this.props/this.state/this.context. */
 const ConversationScreen = (props) => {
  const noticeBar = _react.useContext.call(void 0, _noticeBar.NoticeBarContext)
  const [state, setFullState] = _react.useState.call(void 0, INITIAL_STATE)

  const pendingCallbacks = _react.useRef([])
  const setState = _react.useCallback.call(void 0, (update, callback) => {
    if (callback) pendingCallbacks.current.push(callback)
    setFullState(prev => ({ ...prev, ...update }))
  }, [])

  const latest = _react.useRef.call(void 0, { props, state, noticeBar })
  const prevProps = _react.useRef(null)

  // Instance fields on the class. The container height is never read; it is
  // kept because measuring it (a layout read) is what the class did.
  const dropzoneRef = _react.useRef(null)
  const chatBoxContainerHeight = _react.useRef.call(void 0, 0)
  // Per conversation, the send still delivering files, if any. A later send
  // in that conversation waits for it; other conversations don't.
  const sendQueues = _react.useRef.call(void 0, new Map())
  // The tray session the waiting files were read in (see stagedFiles).
  const trayFrom = _react.useRef.call(void 0, _stagedFiles.stagedFiles.session())
  const composerRef = _react.useRef(null)

  // Send later and the Scheduled bubbles' actions. The flow reads the draft
  // and replaces it through the composer's handle, and the reply through the
  // reply bar.
  const scheduledComposer = _react.useMemo.call(void 0, () => ({
    getDraft: () => ({ text: latest.current.state.currentMessage, mentions: latest.current.state.mentions }),
    replaceDraft: (text, mentions) => {
      if (composerRef.current) composerRef.current.replaceDraft(text, mentions)
      else setState({ currentMessage: text, mentions: mentions ? [...mentions] : [] })
    },
    getReply: () => latest.current.state.replyingTo,
    replaceReply: reply => setState({ replyingTo: reply }),
  }), [setState])
  const notifyScheduled = _react.useCallback.call(void 0, 
    (text) => latest.current.noticeBar.showNoticeBar({ type: 'warning', text }),
    [],
  )
  const scheduled = _useScheduledMessageFlow.useScheduledMessageFlow.call(void 0, {
    conversationKey: props.conversationKey,
    composer: scheduledComposer,
    notify: notifyScheduled,
    channel: _composer.composerChannelFor.call(void 0, props.conversationType),
  })
  const scheduledRef = _react.useRef.call(void 0, scheduled)
  _react.useLayoutEffect.call(void 0, () => {
    scheduledRef.current = scheduled
  })
  // While a scheduled message is being edited the composer holds its text;
  // leaving the chat saves the draft from before the edit instead.
  const draftToSave = _react.useCallback.call(void 0, (state) => {
    const stashed = scheduledRef.current.draftWhileEditing()
    return stashed ? { currentMessage: stashed.text, mentions: [...stashed.mentions], fromTemplate: false } : state
  }, [])
  // Leaving the app (closing the tab, or switching away from it) sends the
  // cancels still waiting for Undo.
  _react.useEffect.call(void 0, () => {
    const onHidden = () => {
      if (document.visibilityState === 'hidden') _scheduledCancels2.default.commitAll()
    }
    window.addEventListener('pagehide', _scheduledCancels2.default.commitAll)
    document.addEventListener('visibilitychange', onHidden)
    return () => {
      window.removeEventListener('pagehide', _scheduledCancels2.default.commitAll)
      document.removeEventListener('visibilitychange', onHidden)
    }
  }, [])

  const reset = _react.useCallback.call(void 0, ({ clearReply = false, keepCurrentMessage = false } = {}) => {
    const { lastSeenTime, readOnly, draft, draftMentions, draftFromTemplate = false, conversationKey, location } = latest.current.props
    const messageKey = getMessageKey(location)
    const hasMessage = messageKey && messageKey !== _uuid.EMPTY_BLUID

    const update = {
      endReachedBelow: false,
      loadingAbove: false,
      loadingBelow: false,
      finishedInitialLoad: false,
      currentMessage: keepCurrentMessage ? latest.current.state.currentMessage : draft,
      readOnly: readOnly,
    }
    if (clearReply) update.replyingTo = null
    // This chat's waiting files, kept while another chat was open.
    if (!keepCurrentMessage) {
      update.pendingFiles = _stagedFiles.stagedFiles.get(conversationKey)
      trayFrom.current = _stagedFiles.stagedFiles.session()
    }
    if (!keepCurrentMessage) {
      update.mentions = draftMentions
      update.fromTemplate = draftFromTemplate
      update.draftKey = conversationKey
    }

    setState(update, () => {
      const loadLatestMessages =
        () => _actions2.default.loadConversation({
          ConversationKey: conversationKey,
          Limit: MSGS_PER_BATCH,
        })

      const loadRelevantBatch = () => (hasMessage
        ? _actions2.default.loadConversationAroundMessage({
          MessageKey: messageKey , // SAFETY: hasMessage checked it
          ConversationKey: conversationKey,
          Limit: MSGS_PER_BATCH,
        })
        : _actions2.default.loadConversationAroundTime({
          Time: lastSeenTime,
          ConversationKey: conversationKey,
          Limit: MSGS_PER_BATCH,
        }))

      const { showNoticeBar } = latest.current.noticeBar

      loadRelevantBatch()
        .then(({ Conversations = {} }) => {
          const conversation = Conversations[conversationKey]
          if (!conversation) return loadLatestMessages()

          const conversationMaxSequence = conversation.MessageSequence
          // Every loaded conversation carries its Messages map.
          const batchMaxSequence = Object.values(conversation.Messages)
            .reduce((acc, m) => Math.max(m.Sequence, acc), 0)

          // The batch we just loaded doesn't include latest messages,
          // need to pull them too to be able to "jump to the bottom".
          if (batchMaxSequence < conversationMaxSequence) {
            return loadLatestMessages()
          }
        })
        .catch(() => showNoticeBar({ type: 'warning', text: "Couldn't load messages" }))
        .finally(() => setState({ finishedInitialLoad: true }))
    })
  }, [setState])

  // After every commit: sync what the handlers read, run componentDidUpdate
  // (not after the first render), then the setState callbacks this commit
  // applied. The queue is taken first, so a callback that componentDidUpdate
  // queues (via reset) waits for the commit that applies its update, as the
  // class's did.
  //
  // The ref syncs after the children's layout effects; no child calls these
  // handlers from a layout effect (react-waypoint defers its callbacks).
  _react.useLayoutEffect.call(void 0, () => {
    const callbacks = pendingCallbacks.current
    pendingCallbacks.current = []
    latest.current = { props, state, noticeBar }
    const previous = prevProps.current
    prevProps.current = props

    if (previous) {
      const currentKey = props.conversationKey
      const prevKey = previous.conversationKey
      const messageKey = getMessageKey(props.location)
      const prevMessageKey = getMessageKey(previous.location)

      if (currentKey !== prevKey || messageKey !== prevMessageKey) {
        const isSameConversation = currentKey === prevKey
        saveConversationDraft(prevKey, draftToSave(state))
        if (!isSameConversation) _stagedFiles.stagedFiles.set(prevKey, state.pendingFiles, trayFrom.current)
        // Jumping to a message inside the conversation we're already in must not
        // disturb what's being typed — the reply bar jumps mid-compose.
        reset({
          clearReply: !isSameConversation,
          keepCurrentMessage: isSameConversation,
        })
        focusComposer()
      }
    }

    callbacks.forEach(callback => callback())
  })

  // componentDidMount / componentWillUnmount.
  _react.useLayoutEffect.call(void 0, () => {
    reset()
    return () => {
      const { props: { conversationKey }, state } = latest.current
      saveConversationDraft(conversationKey, draftToSave(state))
      _stagedFiles.stagedFiles.set(conversationKey, state.pendingFiles, trayFrom.current)
    }
  }, [reset, draftToSave])

  const setDropZoneRef = _react.useCallback.call(void 0, (ref) => {
    dropzoneRef.current = ref
    chatBoxContainerHeight.current = dropzoneRef.current ? dropzoneRef.current.node.offsetHeight : 0
  }, [])

  const updateMessage = _react.useCallback.call(void 0, (msg) => {
    setState({
      currentMessage: msg,
    })
  }, [setState])

  const onComposerChange = _react.useCallback.call(void 0, (_err, value) => updateMessage(value), [updateMessage])

  const onMentionsChange = _react.useCallback.call(void 0, (mentions) => setState({ mentions }), [setState])
  const setFromTemplate = _react.useCallback.call(void 0, (fromTemplate) => setState({ fromTemplate }), [setState])

  // The Dropzone is mounted whenever the composer is.
  const openFilePicker = _react.useCallback.call(void 0, () => dropzoneRef.current.open(), [])

  // Paste, drop and the attach button only stage files; nothing is uploaded
  // until Send.
  const addFiles = _react.useCallback.call(void 0, (files) => {
    const { state: { pendingFiles }, noticeBar: { showNoticeBar } } = latest.current
    const room = Math.max(0, _attachments.MAX_ATTACHMENTS_PER_SEND - pendingFiles.length)
    const leftOut = files.slice(room)
    if (leftOut.length) showNoticeBar({ type: 'warning', text: notAddedText(leftOut) })
    const added = files.slice(0, room).map(file => ({ id: _stagedFiles.stagedFiles.nextId(), file }))
    setState({ pendingFiles: [...pendingFiles, ...added] }, focusComposer)
  }, [setState])

  // Focus moves to the next file's remove button, or back to the composer
  // once the tray is empty.
  const removeFile = _react.useCallback.call(void 0, (id) => {
    const { pendingFiles } = latest.current.state
    const index = pendingFiles.findIndex(pending => pending.id === id)
    setState({ pendingFiles: pendingFiles.filter(pending => pending.id !== id) }, () => {
      const buttons = document.querySelectorAll('.attachment-tray--remove')
      const next = buttons[Math.min(index, buttons.length - 1)]
      if (next) next.focus()
      else focusComposer()
    })
  }, [setState])

  // Escape in the message box or the tray clears the tray. The mention
  // picker claims it first (it prevents the default), and Escape in the emoji
  // picker only closes that picker.
  const onComposerKeyDown = _react.useCallback.call(void 0, (e) => {
    if (e.key !== 'Escape' || e.defaultPrevented || !latest.current.state.pendingFiles.length) return
    const target = e.target 
    if (target.id === 'main-input' || target.closest('.attachment-tray')) setState({ pendingFiles: [] })
  }, [setState])

  const sendMessage = _react.useCallback.call(void 0, () => {
    const { props: { conversationKey, conversationType, location }, state: current } = latest.current
    const messageKey = getMessageKey(location)
    const hasSelectedMessage = messageKey !== undefined
    const msg = current.currentMessage
    const replyingTo = current.replyingTo
    // Keep the textarea coordinates untouched. The shared send action owns the
    // single text sanitation/UTF-16 offset normalization step for every caller.
    const mentions = current.mentions
    // Editing a scheduled message: Send saves its text instead.
    if (scheduledRef.current.editing) {
      scheduledRef.current.saveEdit(msg).catch(() => null)
      return
    }
    const files = current.pendingFiles.map(pending => ({ file: pending.file, MessageKey: _uuid.uuidv4.call(void 0, )  }))

    // Files go as one message with the text as their caption; nothing posts
    // unless every file uploads. A later send in this conversation waits for
    // this one, so its text can't arrive first.
    const send = async () => {
      if (files.length) {
        const caption = _string.isBlank.call(void 0, msg) ? '' : msg
        await _actions2.default.sendConversationAttachments(
          conversationKey,
          files,
          caption,
          _optionalChain([replyingTo, 'optionalAccess', _10 => _10.messageKey]),
          _optionalChain([replyingTo, 'optionalAccess', _11 => _11.preview]),
          caption ? mentions : [],
        )
          .catch(() => null)
        return
      }
      if (_string.isBlank.call(void 0, msg)) return
      // A plain SMS longer than one text goes as numbered texts, in order.
      if (conversationType === _chat.CHAT_TYPE.REGULAR_PATIENT && msg.length > _composer.SMS_PART_LENGTH) {
        await _actions2.default.sendConversationSmsParts(
          conversationKey, msg, _optionalChain([replyingTo, 'optionalAccess', _12 => _12.messageKey]), _optionalChain([replyingTo, 'optionalAccess', _13 => _13.preview]), mentions,
        )
          .catch(() => null)
        return
      }
      await _actions2.default.sendConversationMessage(
        conversationKey,
        msg,
        undefined,
        undefined,
        _optionalChain([replyingTo, 'optionalAccess', _14 => _14.messageKey]),
        _optionalChain([replyingTo, 'optionalAccess', _15 => _15.preview]),
        mentions,
      )
        .catch(() => null)
    }

    setState(
      { currentMessage: "", replyingTo: null, mentions: [], pendingFiles: [], fromTemplate: false },
      () => {
        const queues = sendQueues.current
        const earlier = queues.get(conversationKey)
        const queued = earlier ? earlier.then(send) : send()
        queues.set(conversationKey, queued)
        queued.finally(() => {
          if (queues.get(conversationKey) === queued) queues.delete(conversationKey)
        })
      },
    )

    if (hasSelectedMessage) {
      _store.history.replace(location.pathname)

      /* a timeout because I guess the replace api is non-synchronous???? */
      setTimeout(reset, 50)
    }
  }, [setState, reset])

  const onRetrySendMessage = _react.useCallback.call(void 0, (messageKey, text, mentions) => {
    const { conversationKey } = latest.current.props
    if (_string.isBlank.call(void 0, text)) return

    // A numbered part waits there while an earlier part of its text is not sent.
    _actions2.default.retryConversationTextMessage(conversationKey, messageKey, text, mentions)
      .catch(() => null)
  }, [])

  const onRetrySendFile = _react.useCallback.call(void 0, (messageKey, fileKey) => {
    const { conversationKey } = latest.current.props

    _actions2.default.sendConversationFile(conversationKey, null, messageKey, fileKey)
      .catch(() => null)
  }, [])

  const onAbortSendFile = _react.useCallback.call(void 0, (MessageKey, options = {}) => {
    _actions2.default.abortSendConversationFile(MessageKey)

    const { pruneTimeout } = options
    if (pruneTimeout) {
      const { conversationKey } = latest.current.props
      setTimeout(
        () => _actions2.default.pruneLocalMessage({ ConversationKey: conversationKey, MessageKey }),
        pruneTimeout,
      )
    }
  }, [])

  const onMarkMessageSeen = _react.useCallback.call(void 0, (message) => {
    const { lastSeenTime, blobjectKey, totalMessagesCount, inboxSortTime } = latest.current.props

    if (
      !message || !message.MessageKey ||
      _time.isAfter.call(void 0, lastSeenTime, message.SentAt)
    ) return

    // Seeing the newest message reads the whole chat, events after it too.
    const isNewest = (_nullishCoalesce(message.Sequence, () => ( 0))) >= (_nullishCoalesce(totalMessagesCount, () => ( Infinity)))
    const SeenTime = isNewest ? _nullishCoalesce(_markReadOnOpen.readThroughTime.call(void 0, inboxSortTime, message.SentAt), () => ( message.SentAt)) : message.SentAt
    _actions2.default.markBlobjectSeen({ BKey: blobjectKey, SeenTime })
      .catch(() => null)
  }, [])

  const onCopyMessageLink = _react.useCallback.call(void 0, (messageKey) => {
    const { props: { blobjectKey, conversationKey, conversationType }, noticeBar: { showNoticeBar } } = latest.current
    // SAFETY: a missing type builds an empty route (buildBlobjectRoute checks for it).
    const blobjectRoute = _navigation.buildBlobjectRoute.call(void 0, {
      blobjectKey, conversationType: conversationType , conversationKey, messageKey,
    })
    const blobjectURL = _navigation.makeFullURL.call(void 0, blobjectRoute)

    _ui.copyToClipboard.call(void 0, blobjectURL)
      .then(() => showNoticeBar({ type: 'success', text: 'Link has been copied' }))
  }, [])

  const onReply = _react.useCallback.call(void 0, (message) => {
    const snippet = (message.MessageText || message.FileName || '').slice(0, 120)
    // SAFETY: rows passed to onReply are message rows, which have a MessageKey.
    const preview = {
      MessageKey: message.MessageKey,
      DisplayName: message.DisplayName,
      SenderType: message.SenderType,
      MessageType: message.MessageType,
      ...(message.MessageType === 'file'
        ? {
            FileName: message.FileName,
            ThumbnailURL: _optionalChain([message, 'access', _16 => _16.FileInfo, 'optionalAccess', _17 => _17.ThumbnailURL]),
            Mime: _optionalChain([message, 'access', _18 => _18.FileInfo, 'optionalAccess', _19 => _19.Mime]),
          }
        : { Snippet: snippet }),
    } 

    // SAFETY: as above.
    setState(
      {
        replyingTo: {
          messageKey: message.MessageKey ,
          preview,
        },
      },
      // Picking "Reply" means you're about to type — don't make them click in.
      focusComposer,
    )
  }, [setState])

  const cancelReply = _react.useCallback.call(void 0, () => setState({ replyingTo: null }, focusComposer), [setState])

  const onJumpToMessage = _react.useCallback.call(void 0, (messageKey) => {
    const { blobjectKey, conversationKey, conversationType } = latest.current.props
    // SAFETY: a missing type builds an empty route (buildBlobjectRoute checks for it).
    _store.history.replace(_navigation.buildBlobjectRoute.call(void 0, {
      blobjectKey, conversationType: conversationType , conversationKey, messageKey,
    }))
  }, [])

  const jumpToReplyTarget = _react.useCallback.call(void 0, () => {
    const { replyingTo } = latest.current.state
    if (replyingTo) onJumpToMessage(replyingTo.messageKey)
  }, [onJumpToMessage])

  const onDeleteMessage = _react.useCallback.call(void 0, (messageKey, conversationKey) =>
    setState({
      messageToDelete: { messageKey, conversationKey },
    }), [setState])

  const onAddReaction = _react.useCallback.call(void 0, (messageKey, emoji, conversationKey) =>
    _actions2.default.addMessageReaction(messageKey, emoji, conversationKey)
      .catch(() => latest.current.noticeBar.showNoticeBar({ type: 'warning', text: 'Failed to add reaction' })),
  [])

  const onRemoveReaction = _react.useCallback.call(void 0, (messageKey, emoji, conversationKey) =>
    _actions2.default.removeMessageReaction(messageKey, emoji, conversationKey)
      .catch(() => latest.current.noticeBar.showNoticeBar({ type: 'warning', text: 'Failed to remove reaction' })),
  [])

  const clearMessageToDelete = _react.useCallback.call(void 0, () => setState({ messageToDelete: null }), [setState])

  const onConfirmDeleteMessage = _react.useCallback.call(void 0, () => {
    const { state: current, noticeBar: { showNoticeBar } } = latest.current
    if (current.messageToDelete) {
      const { messageKey, conversationKey } = current.messageToDelete
      clearMessageToDelete()
      // Only this message: a caption drawn under a file stays (processMessages).
      _actions2.default.deleteMessageFromConversation(messageKey, conversationKey)
        .catch(() => showNoticeBar({ type: 'warning', text: 'Failed to recall message' }))
    }
  }, [clearMessageToDelete])

  const onLoadAbove = _react.useCallback.call(void 0, (earliestMessage) => {
    const { props: current, state: currentState } = latest.current
    if (earliestMessage.Sequence === 1 || !currentState.finishedInitialLoad) {
      return Promise.resolve()
    }

    setState({ loadingAbove: true })

    // SAFETY: resolves to null on failure; the caller only waits for it.
    return _actions2.default.loadConversation({
      ConversationKey: current.conversationKey,
      Limit: MSGS_PER_BATCH,
      Seq: earliestMessage.Sequence,
    })
      .then(() => setState({ loadingAbove: false }))
      .catch(() => null) 
  }, [setState])

  const onLoadBelow = _react.useCallback.call(void 0, (latestMessage) => {
    const { props: current, state: currentState } = latest.current
    if (
      // SAFETY: an unknown count compares false, as it did in the JS.
      latestMessage.Sequence >= (current.totalMessagesCount ) ||
      !currentState.finishedInitialLoad ||
      currentState.endReachedBelow ||
      currentState.loadingBelow
    ) {
      return Promise.resolve()
    }

    setState({ loadingBelow: true })
    const { conversationKey } = current
    // SAFETY: resolves to undefined on failure; the caller only waits for it.
    return _actions2.default.loadConversation({
      ConversationKey: conversationKey,
      Limit: MSGS_PER_BATCH,
      Seq: latestMessage.Sequence + MSGS_PER_BATCH,
    })
      .then(res => {
        const conversation = res.Conversations && Object.keys(res.Conversations).length > 0 ? Object.values(res.Conversations)[0] : null
        if (conversation === null) {
          throw new Error("Invalid chat key")
        }

        const messages = conversation.Messages && Object.values(conversation.Messages).length > 0 ? Object.values(conversation.Messages) : null
        if (messages == null) {
          throw new Error("No Messages")
        }

        const latestServerMessage = messages.sort((a, b) => _sort.sortByInt.call(void 0, a.Sequence, b.Sequence))[0]

        setState({
          loadingBelow: false,
          endReachedBelow: latestServerMessage.Sequence === latestMessage.Sequence,
        })
      })
      .catch(_log.log.error) 
  }, [setState])

  const {
    blobjectKey,
    conversationKey,
    conversationType,
    location,
    readOnly,
    myOrgKey,
    amIOrgless,
    mentionCandidates,
    sendingNumber,
    cancelRecipientName,
  } = props

  const messageKey = getMessageKey(location)
  const canDeleteMessages = conversationType !== _chat.CHAT_TYPE.REGULAR_PATIENT
  // Left the chat: the case the rejoin prompt opens for.
  const hasLeft = myOrgKey === _uuid.EMPTY_BLUID && !amIOrgless
  // An archived chat keeps its composer: archive files a chat out of an
  // inbox, and a send brings it back for everyone (as a patient's reply does).
  const composerDisabled = readOnly || hasLeft
  const {
    editing, sendLater, sendLaterError, busy: scheduledBusy, scheduleAt, closeSendLater,
    stopEditing, reloadEdit, confirmingCancel, confirmCancel, keepScheduled, openSendLater, runAction,
    cancelToast, undoCancel,
  } = scheduled
  const scheduleTimeZone = _nullishCoalesce(props.scheduleTimeZone, () => ( _timeZones.deviceTimeZone.call(void 0, )))
  const setScheduleTimeZone = _nullishCoalesce(props.onScheduleTimeZoneChange, () => ( KEEP_ZONE))
  const pickSendAt = _react.useCallback.call(void 0, (sendAt) => {
    scheduleAt(sendAt).catch(() => null)
  }, [scheduleAt])
  const closeSendLaterPanel = _react.useCallback.call(void 0, () => {
    closeSendLater()
    focusComposer()
  }, [closeSendLater])
  const editBar = _react.useMemo.call(void 0, 
    () => editing
      ? _react2.default.createElement(_ScheduledEditBar2.default, { editing: editing, timeZone: scheduleTimeZone, onReload: reloadEdit, onStop: stopEditing, __self: this, __source: {fileName: _jsxFileName, lineNumber: 816}} )
      : undefined,
    [editing, scheduleTimeZone, reloadEdit, stopEditing],
  )

  // A plain SMS past one text goes as numbered texts, not cut: the field (and
  // a template inserted into it) only stops at the sanity cap.
  const maxLength = conversationType === _chat.CHAT_TYPE.REGULAR_PATIENT ? _composer.PLAIN_SMS_MAX_LENGTH : _message.MAX_MESSAGE_LENGTH
  const showTemplateTooLong = _react.useCallback.call(void 0, () => noticeBar.showNoticeBar({
    type: 'warning',
    text: 'That template would make the message longer than this chat allows. Shorten the message or pick a shorter template.',
  }), [noticeBar])
  const templates = _ComposerTemplates.useComposerTemplates.call(void 0, {
    orgKey: myOrgKey && myOrgKey !== _uuid.EMPTY_BLUID ? myOrgKey : null,
    blobjectKey,
    value: state.currentMessage,
    fromTemplate: state.fromTemplate,
    onFromTemplateChange: setFromTemplate,
    composer: composerRef,
    maxLength,
    onTooLong: showTemplateTooLong,
  })
  const aboveComposerField = _react.useMemo.call(void 0, () => _react2.default.createElement(_react2.default.Fragment, null, editBar, templates.picker), [editBar, templates.picker])
  const sendForm = _useComposerSendForm.useComposerSendForm.call(void 0, {
    orgKey: myOrgKey && myOrgKey !== _uuid.EMPTY_BLUID ? myOrgKey : null,
    conversationKey,
    chat: props.formsChat,
  })
  const composerActionHandlers = _react.useMemo.call(void 0, 
    () => ({ ...templates.actionHandlers, ...sendForm.actionHandlers }),
    [templates.actionHandlers, sendForm.actionHandlers],
  )
  const statusLine = _react.useMemo.call(void 0, () => ({
    channel: _composer.composerChannelFor.call(void 0, conversationType),
    sendingNumber,
  }), [conversationType, sendingNumber])

  return (
    _react2.default.createElement(_SaveAsTemplateHost2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 854}}
    , _react2.default.createElement('div', { className: "chat--messagingSection", __self: this, __source: {fileName: _jsxFileName, lineNumber: 855}}
      , _react2.default.createElement(_SearchHitInThread2.default, { conversationKey: conversationKey, messageKey: messageKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 856}} )
      , _react2.default.createElement(_reactdropzone2.default, {
        inputProps: DROPZONE_INPUT_PROPS,
        onDrop: addFiles,
        className: "chatbox--dropzone",
        ref: setDropZoneRef,
        disableClick: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 857}}

        , _react2.default.createElement(_StoreConversationBox2.default, {
          key: conversationKey + messageKey,
          highlightedMessageKey: messageKey,
          conversationKey: conversationKey,
          blobjectKey: blobjectKey,
          isLoadingAbove: state.loadingAbove,
          isLoadingBelow: state.loadingBelow,
          onLoadAbove: onLoadAbove,
          onLoadBelow: onLoadBelow,
          onDelete: onDeleteMessage,
          recallOnlyAwaitingConsent: !canDeleteMessages,
          onAddReaction: onAddReaction,
          onRemoveReaction: onRemoveReaction,
          onCopyMessageLink: onCopyMessageLink,
          onReply: onReply,
          onJumpToMessage: onJumpToMessage,
          readOnly: readOnly,
          onRetrySendMessage: onRetrySendMessage,
          onRetrySendFile: onRetrySendFile,
          onAbortSendFile: onAbortSendFile,
          onMarkMessageSeen: onMarkMessageSeen,
          onScheduledAction: runAction, __self: this, __source: {fileName: _jsxFileName, lineNumber: 864}}
        )
      )
      , _react2.default.createElement(MemoConfirmDeleteMessageModal, {
        isOpen: !!state.messageToDelete,
        onClose: clearMessageToDelete,
        onProceed: onConfirmDeleteMessage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 888}}
      )
      , _react2.default.createElement(_CancelScheduledModal2.default, {
        isOpen: !!confirmingCancel,
        recipientName: cancelRecipientName,
        onClose: keepScheduled,
        onProceed: confirmCancel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 893}}
      )
      , _react2.default.createElement(_ScheduledCancelToast2.default, { toast: cancelToast, onUndo: undoCancel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 899}} )
      , _react2.default.createElement(SMSRejectionNotifier, { conversationKey: conversationKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 900}} )
      , _react2.default.createElement(_SMSUndeliverableBanner2.default, { blobjectKey: blobjectKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 901}} )
      , _react2.default.createElement('div', {
        className: "chat--createMessageBox chat--createMessageBox--stacked" ,
        onKeyDown: onComposerKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 902}}

        ,  !readOnly && (
          _react2.default.createElement(_ComposerHint2.default, {
            conversationKey: conversationKey,
            draft: state.currentMessage,
            mentions: state.mentions, __self: this, __source: {fileName: _jsxFileName, lineNumber: 907}}
          )
        )
        ,  state.replyingTo && (
          _react2.default.createElement(_ReplyBar2.default, {
            preview: state.replyingTo.preview,
            conversationKey: conversationKey,
            messageKey: state.replyingTo.messageKey,
            onCancel: cancelReply,
            onJump: jumpToReplyTarget, __self: this, __source: {fileName: _jsxFileName, lineNumber: 914}}
          )
        )
        , _react2.default.createElement(_UploadStatus2.default, { conversationKey: conversationKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 922}} )
        , state.pendingFiles.length > 0 && _react2.default.createElement(_AttachmentTray2.default, { files: state.pendingFiles, onRemove: removeFile, __self: this, __source: {fileName: _jsxFileName, lineNumber: 923}} )
        , sendLater && (
          _react2.default.createElement(_SendLaterPanel2.default, {
            title: _scheduledMessages.sendLaterPanelText.call(void 0, sendLater.kind).title,
            submitLabel: _scheduledMessages.sendLaterPanelText.call(void 0, sendLater.kind).submitLabel,
            error: sendLaterError,
            busy: scheduledBusy,
            timeZone: scheduleTimeZone,
            onTimeZoneChange: setScheduleTimeZone,
            onPick: pickSendAt,
            onClose: closeSendLaterPanel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 925}}
          )
        )
        , _react2.default.createElement(_ExpandingInput2.default, {
          ref: composerRef,
          variant: "full",
          draftKey: _nullishCoalesce(state.draftKey, () => ( undefined)),
          onSendLater: editing ? undefined : openSendLater,
          sendLabel: editing ? _scheduledMessages.scheduledEditBarText.call(void 0, editing).saveLabel : undefined,
          keepDraftOnSend: !!editing,
          aboveField: aboveComposerField,
          statusLine: statusLine,
          actionHandlers: composerActionHandlers,
          patientCount: sendForm.patientCount,
          onTypedTrigger: templates.onTypedTrigger,
          onKeyDownFirst: templates.onKeyDownFirst,
          chipRanges: templates.chipRanges,
          sendGate: templates.sendGate,
          onChange: onComposerChange,
          maxLength: maxLength,
          onAttachmentClick: openFilePicker,
          onPasteFiles: addFiles,
          onSend: sendMessage,
          hasAttachments: state.pendingFiles.length > 0,
          value: state.currentMessage,
          disabled: composerDisabled,
          placeholder: conversationType === _chat.CHAT_TYPE.REGULAR_PATIENT
            ? _secureText.INSECURE_COMPOSER_PLACEHOLDER_WEB
            : undefined
          ,
          mentions: state.mentions,
          mentionCandidates: mentionCandidates,
          onMentionsChange: onMentionsChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 936}}
        )
      )
      , templates.dialog
      , sendForm.sheet
      , _react2.default.createElement(MemoRejoinModal, {
        isOpen: myOrgKey === _uuid.EMPTY_BLUID && !amIOrgless,
        conversationKey: conversationKey,
        onClose: _actions2.default.gotoInbox, __self: this, __source: {fileName: _jsxFileName, lineNumber: 970}}
      )
    )
    )
  )
}; exports.ConversationScreen = ConversationScreen

/* connect(mapState)(withRouter(shim)): memo keeps connect's shallow-equal
 * own-props bail-out, the selector result is compared shallowly as connect
 * compared mapState's, and useLocation re-renders on navigation as
 * withRouter did. The screen mounts only once the blobject has a last-seen
 * time. */
const ConnectedConversationScreen = (ownProps) => {
  const stateProps = _hooks.useAppSelector.call(void 0, state => selectScreenState(state, ownProps), _reactredux.shallowEqual)
  const selectMentionCandidates = _react.useMemo.call(void 0, makeSelectMentionCandidates, [])
  const mentionCandidates = _hooks.useAppSelector.call(void 0, state => selectMentionCandidates(state, ownProps.blobjectKey))
  const formsChat = _hooks.useAppSelector.call(void 0, 
    state => _useComposerSendForm.selectFormsComposerChat.call(void 0, state, ownProps.blobjectKey, stateProps.myOrgKey),
    _reactredux.shallowEqual,
  )
  const location = _reactrouterdom.useLocation.call(void 0, )
  // Read back once a chat opens, so its Scheduled bubbles show the zone too.
  const { timeZone, setTimeZone } = _scheduleTimeZone.useScheduleTimeZone.call(void 0, )

  return stateProps.lastSeenTime
    ? (
        _react2.default.createElement(exports.ConversationScreen, {
          ...ownProps, ...stateProps, location: location, mentionCandidates: mentionCandidates,
          scheduleTimeZone: timeZone, onScheduleTimeZoneChange: setTimeZone, formsChat: formsChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 999}}
        )
      )
    : null
}

exports. default = _react.memo.call(void 0, ConnectedConversationScreen)
